import React, { FC, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Button, Container, Heading, Icon } from "@telia/teddy";
import { RootState } from "../../../../../models";
import { getFeatureToggles } from "../../../app/state/selectors";
import NexusLogoSymbol from "../../components/atoms/NexusLogoSymbol/NexusLogoSymbol";
import SupportLinks from "../../components/molecules/SupportLinks/SupportLinks";
import DealerCodeLoginModal from "../../components/DealerCodeLoginModal/DealerCodeLoginModal";
import PAGES from "../../../../../constants/pages";
import { API_URL_IDP_AUTHORIZE } from "../../api";
import "./Landing.less";

const LandingPage: FC = () => {
    const [showDealerModal, setShowDealerModal] = useState(false);
    const enableRetailerPiamLogin = useSelector(
        (state: RootState) => !!getFeatureToggles(state).enableRetailerPiamLogin,
    );
    const enableRetailerDealerLogin = useSelector(
        (state: RootState) => !!getFeatureToggles(state).enableRetailerDealerLogin,
    );

    const handleLogin = async () => {
        const fallbackUrl = PAGES.RETAILER.SHOPS.URL;
        try {
            const res = await fetch(`${API_URL_IDP_AUTHORIZE}?mode=piam`);
            if (!res.ok) {
                window.location.assign(fallbackUrl);
                return;
            }

            const responseData = await res.json();
            const redirectUrl = responseData?.redirectUrl;
            window.location.assign(redirectUrl || fallbackUrl);
        } catch {
            window.location.assign(fallbackUrl);
        }
    };

    return (
        <div
            className="nexus-landing"
            style={{ backgroundImage: "url(/shop/assets/img-static/retailer/reseller-background.png)" }}
        >
            <Container className="nexus-landing__container">
                <Box className="nexus-landing__card">
                    <div className="nexus-landing__logo">
                        <NexusLogoSymbol />
                        <Heading mb="100" as="h1" variant="title-300" className="nexus-landing__logo-text">
                            Telia Nexus
                        </Heading>
                    </div>

                    {enableRetailerDealerLogin && (
                        <Button
                            variant="primary"
                            size="lg"
                            className="nexus-landing__login-button"
                            onClick={() => setShowDealerModal(true)}
                        >
                            <Icon name="login" aria-hidden="true" focusable="false" />
                            Logg inn (m/SMS)
                        </Button>
                    )}

                    {enableRetailerPiamLogin && (
                        <Button
                            variant="primary"
                            size="lg"
                            className="nexus-landing__login-button"
                            onClick={handleLogin}
                        >
                            <Icon name="login" aria-hidden="true" focusable="false" />
                            Logg inn
                        </Button>
                    )}

                    <SupportLinks />
                </Box>
            </Container>

            <DealerCodeLoginModal open={showDealerModal} onClose={() => setShowDealerModal(false)} />
        </div>
    );
};

export default LandingPage;
